import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';
import MobDailyStatistics from './DailyStatistics';
import ChannelStatistics from './ChannelStatistics';
import MediaStatistics from './MediaStatistics';

const Mobfeed = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };
  // 테스트
  return (
    <MainTemplate>
      <MbTabs
        name="Mobfeed"
        tabMenuList={tabList()}
        tabs={{
          //일자별통계
          '/report/mobfeed/daily': {
            tabComponent: <MobDailyStatistics />,
          },
          //채널별통계
          '/report/mobfeed/channel': {
            tabComponent: <ChannelStatistics />,
          },
          //언론별통계
          '/report/mobfeed/media': {
            tabComponent: <MediaStatistics />,
          },
        }}
      />
    </MainTemplate>
  );
};

export default Mobfeed;
